<template>
  <admin title="Formulário plano" menu="Planos">
    <div class="row">
      <div class="col-xs-12 col-lg-2"></div>
      <div class="col-lg-8 col-xs-12">
        <div id="new-job-box" class="bg_black color-light-grey">
          <div class="card mt-3">
            <div class="card-body">
              <div class="container-form">
                <div class="row">
                  <div class="col-lg-12 col-xs-12">
                    <inputform
                      v-model="plan.name"
                      type="text"
                      label="Título do plano"
                      :field="$v.plan.name"
                    />
                  </div>
                  <div class="col-lg-12 col-xs-12">
                    <textareaform
                      label="Descrição"
                      rows="5"
                      :field="$v.plan.description"
                      v-model="plan.description"
                    ></textareaform>
                  </div>
                  <div class="col-lg-6 col-xs-12">
                    <label>Status</label>
                    <select class="form-control" v-model="plan.status">
                      <option :value="1">Ativo</option>
                      <option :value="0">Desativado</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-xs-12">
                    <label>Visibilidade</label>
                    <select class="form-control" v-model="plan.visibility">
                      <option :value="1">Ativo</option>
                      <option :value="0">Desativado</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-xs-12">
                    <label class="mt-2">Quantidade de vagas</label>
                    <input
                      type="number"
                      v-model="plan.amount_jobs"
                      class="form-control"
                      value="1"
                    />
                  </div>
                  <div class="col-lg-6 col-xs-12">
                    <label class="mt-2">Quantidade de usuários</label>
                    <input
                      type="number"
                      v-model="plan.amount_recruiters"
                      class="form-control"
                      value="1"
                    />
                  </div>
                  <div class="col-lg-6 col-xs-12">
                    <label class="mt-2">Preço mensal</label>
                    <div class="bg_menu_dark input-group mb-3">
                      <div class="bg_menu_dark input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"
                          >R$</span
                        >
                      </div>
                      <currency-input
                        v-model="plan.price"
                        :disabled="this.plan_record ? true : false"
                        class="form-control"
                        placeholder="0,00"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-xs-12">
                    <label class="mt-2">Quantidade de dias free</label>
                    <input
                      type="number"
                      v-model="plan.day_free"
                      class="form-control"
                    />
                  </div>
                  <div class="col-lg-12 col-xs-12">
                    <label class="mt-3">Tipo de pagamento</label>
                    <div class="mb-3">
                      <label class="mr-4">
                        <input
                          type="checkbox"
                          :disabled="this.plan_record ? true : false"
                          id="boleto"
                          v-model="payment_methods"
                          class="mr-1"
                          value="boleto"
                        />
                        Boleto
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          :disabled="this.plan_record ? true : false"
                          id="credit_card"
                          v-model="payment_methods"
                          class="mr-1"
                          value="credit_card"
                        />
                        Cartão de crédito
                      </label>
                    </div>
                  </div>
                  <div v-if="url_full != ''" class="col-lg-12 mb-4 col-xs-12">
                    <span
                      class="pointer color-grey"
                      v-clipboard:copy="url_full"
                      v-clipboard:success="onCopy"
                    >
                      {{ url_full }}
                      <font-awesome-icon icon="paperclip" />
                    </span>
                  </div>
                  <div class="col-lg-6 col-xs-12">
                    <button
                      @click="save"
                      class="btn btn-degrade full normal-degrade"
                    >
                      {{ !load ? "Salvar" : "" }}
                      <div
                        v-show="load"
                        class="spinner-border text-light"
                        role="status"
                      >
                        <span class="sr-only"></span>
                      </div>
                    </button>
                  </div>
                  <div class="col-lg-6 col-xs-12">
                    <inertia-link href="/admins/plans">
                      <button class="btn btn-secondary full">Voltar</button>
                    </inertia-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </admin>
</template>

<script>
import { required, minLength, email } from "vuelidate/lib/validators";
export default {
  props: ["plan_record"],
  data: () => ({
    load: false,
    plan_id: 0,
    payment_methods: ["credit_card", "boleto"],
    url_full: "",
    plan: {
      name: "",
      description: "",
      status: 1,
      visibility: 1,
      amount_jobs: 1,
      amount_recruiters: 1,
      day_free: 0,
      price: 0,
      payment_methods: [],
    },
  }),
  mounted() {
    if (this.plan_record) {
      this.plan_id = this.plan_record.id;
      // url_full =  "",
      this.plan = {
        name: this.plan_record.name,
        description: this.plan_record.description,
        status: this.plan_record.status ? 1 : 0,
        visibility: this.plan_record.visibility ? 1 : 0,
        amount_jobs: this.plan_record.amount_jobs,
        amount_recruiters: this.plan_record.amount_recruiters,
        day_free: this.plan_record.day_free,
        price: this.plan_record.price,
        payment_methods: this.plan_record.payment_methods,
      };
      this.payment_methods = this.plan_record.payment_methods;
      this.url_full = this.plan_record.url_full;
    }
  },
  methods: {
    onCopy: function (e) {
      this.$toast.success("Link Copiado com sucesso");
    },
    save() {
      this.load = true;
      if (this.plan.amount_jobs <= 0 || this.plan.amount_recruiters <= 0) {
        this.$toast.error("Quantidade de usuário ou de vaga inválidos");
        this.load = false;
        return;
      }

      this.$v.plan.$touch();
      if (this.$v.plan.$error) {
        this.$toast.error("Preencha corretamente os campos para continuar", {
          position: "top",
        });
        this.load = false;

        return false;
      }
      let request = {};

      this.plan.payment_methods = this.payment_methods;
      if (this.plan.payment_methods.length == 0) {
        this.$toast.error("Precisa existir uma forma de pagamento.");
        return;
      }
      if (this.plan_id != 0) {
        request = axios.put("/admins/plans/" + this.plan_id, {
          plans: this.plan,
        });
      } else {
        request = axios.post("/admins/plans", { plans: this.plan });
      }

      request
        .then((response) => {
          this.$toast.success("Plano salvo com sucesso");
          this.load = false;
          this.url_full = response.data.plan.url_full;
          this.plan_id = response.data.plan.id;
        })
        .catch((err) => {
          this.load = false;
        });
    },
  },
  validations: {
    plan: {
      name: { required, minLength: minLength(4) },
      description: { minLength: minLength(5) },
    },
  },
};
</script>

<style>
</style>